// extracted by mini-css-extract-plugin
export default {"game":"Game_game__YH4rG","points":"Game_points__+LpdC","wordContainer":"Game_wordContainer__u7BcQ"};